import React, { useState, useEffect, useRef } from 'react';
import { categories } from '../categories';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router';
import nextSound from "../assets/sounds/next_back.wav"
import startLessonSound from "../assets/sounds/start_lesson.wav"
import hoverSound from "../assets/sounds/hover.wav"
import backSound from "../assets/sounds/back.wav"

// أيقونات المواد
const categoryIcons = {
    "رياضيات 1: الأنماط والأعداد حتى ٩": "🔢",
    "رياضيات 2: الأعداد حتى ١٢ والعمليات الأولية": "🔢",
    "رياضيات 3: الأعداد حتى ٩٩ والمفاهيم المتقدمة": "🔢",
    "اللغة العربية": "📚",
    "العلوم": "🔬",
    "اللغة الانجليزية": "🔤",
    "الاجتماعيات": "🌍"
};

const categoryColors = {
    "رياضيات 1: الأنماط والأعداد حتى ٩": "from-pink-400 to-orange-400",
    "رياضيات 2: الأعداد حتى ١٢ والعمليات الأولية": "from-pink-400 to-orange-400",
    "رياضيات 3: الأعداد حتى ٩٩ والمفاهيم المتقدمة": "from-pink-400 to-orange-400",
    "اللغة العربية": "from-green-400 to-teal-400",
    "العلوم": "from-purple-400 to-indigo-400",
    "اللغة الانجليزية": "from-yellow-400 to-orange-400",
    "الاجتماعيات": "from-blue-400 to-cyan-400"
};

// ===============================================
// 💡 SHARE MODAL COMPONENT
// ===============================================
const ShareModal = ({ isOpen, onClose, shareData }) => {
    if (!isOpen) return null;

    // Dynamic data: Category Name (title) and URL
    const shareLink = `${window.location.origin}/category/${shareData.id}`;
    const shareDescription = `تعال وتعلّم معي في مادة: "${shareData.title}"! هذه الدروس رائعة وممتعة.`;

    // Function to copy link to clipboard
    const handleCopy = () => {
        navigator.clipboard.writeText(shareLink);
        alert('تم نسخ الرابط بنجاح!');
        onClose();
    };

    // Function to handle the Web Share API (for modern browsers/mobile)
    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'مشاركة الفئة',
                    text: shareDescription,
                    url: shareLink,
                });
                onClose();
            } catch (error) {
                console.error('Error sharing', error);
            }
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4 transition-opacity duration-300"
            onClick={onClose}
            dir="rtl"
        >
            <div
                className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform scale-100 transition-transform duration-300"
                onClick={e => e.stopPropagation()}
            >
                <h3 className="text-2xl font-black mb-4 text-pink-600 border-b pb-2">📤 شارك هذه المادة</h3>

                <p className="text-gray-700 mb-4 border-r-4 border-pink-500 pr-3">
                    {shareDescription}
                </p>

                {/* Share Link Preview (Attractive Box) */}
                <div className="bg-gray-100 p-3 rounded-lg flex items-center justify-between mb-6 border border-gray-300">
                    <span className="truncate text-sm font-mono text-gray-600 flex-1">{shareLink}</span>
                    <button
                        onClick={handleCopy}
                        className="bg-pink-500 text-white p-2 rounded-lg hover:bg-pink-600 transition-colors text-sm font-semibold mr-2 shadow-md"
                    >
                        نسخ
                    </button>
                </div>

                {/* Share Options */}
                <div className="flex flex-col space-y-3">
                    {navigator.share && (
                        <button
                            onClick={handleNativeShare}
                            className="w-full py-3 px-4 bg-teal-600 text-white rounded-lg font-bold hover:bg-teal-700 transition-colors shadow-lg flex items-center justify-center"
                        >
                            <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.314l4.94 2.47a3 3 0 10.835-1.668L13 11a3 3 0 000-2l.023-.112a3.003 3.003 0 00-.023-.888zM6 13a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0zm7-4a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                            مشاركة فورية
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className="w-full py-3 px-4 border border-gray-300 text-gray-700 rounded-lg font-bold hover:bg-gray-100 transition-colors"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    );
};


/* ---------------------------
      ✨ Category Header (Updated)
--------------------------- */
const CategoryHeader = ({ categoryName, icon, onBack, onShare }) => {
    return (
        <div className="text-center mb-8 relative px-4">

            {/* Share Button (New) */}
            <button
                onClick={onShare}
                className="fixed md:absolute bottom-4 left-4 md:top-4 bg-white rounded-full p-2 shadow-lg hover:scale-110 transition-transform z-50 focus:outline-none focus:ring-4 focus:ring-white/50"
                style={{ animation: 'pulse 2s infinite' }}
            >
                <span className="text-2xl p-1" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>مشاركة 🚀</span>
            </button>

            <button
                onClick={onBack}
                className="fixed md:absolute bottom-4 right-4 md:top-4 bg-white rounded-full shadow-lg hover:scale-110 transition-transform z-50 focus:outline-none focus:ring-4 focus:ring-white/50"
                style={{ animation: 'pulse 2s infinite' }}
            >
                <span className="text-2xl p-1" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>الصفحة الرئيسية 🏠</span>
            </button>

            <h1 className="text-5xl font-black text-white mb-3" style={{
                textShadow: '4px 4px 0px rgba(0,0,0,0.3)',
                animation: 'float 3s ease-in-out infinite'
            }}>
                {categoryName}
            </h1>

            <div className="w-32 h-2 mx-auto rounded-full bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-400"
                style={{ animation: 'rainbow 3s linear infinite' }} />

            <p className="text-2xl text-white font-bold mt-4" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.2)' }}>
                ✨ اختر الدرس الذي تريد تعلمه! ✨
            </p>
        </div>
    );
};

/* ---------------------------
      ✨ Lesson Card
--------------------------- */
const LessonCard = ({ lesson, index, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    const hoverLessonSound = useRef(new Audio(hoverSound))
    const startLessonSoundObject = useRef(new Audio(startLessonSound))

    return (
        <div
            className="relative bg-white rounded-3xl p-6 cursor-pointer overflow-hidden"
            style={{
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                animation: `slideIn 0.5s ease backwards ${index * 0.1}s`,
                transform: isHovered ? 'translateY(-10px) scale(1.05)' : 'translateY(0) scale(1)',
                transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
            }}
            onMouseEnter={() => {
                setIsHovered(true)
                hoverLessonSound.current.currentTime = 0;
                hoverLessonSound.current.play();
            }}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
                startLessonSoundObject.current.currentTime = 0;
                startLessonSoundObject.current.play();
                onClick();
            }}
        >
            <div
                className="absolute -top-4 -right-4 w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-black"
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                    animation: isHovered ? 'spin 0.6s ease' : 'none'
                }}
            >
                {index + 1}
            </div>

            <div className="flex items-center gap-4">
                <div
                    className="text-5xl"
                    style={{
                        animation: isHovered ? 'bounce 0.6s ease' : 'wiggle 2s ease-in-out infinite',
                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
                    }}
                >
                    📖
                </div>

                <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 leading-relaxed">
                        {lesson.title}
                    </h3>
                </div>

                <div
                    className="text-4xl"
                    style={{
                        animation: isHovered ? 'moveRight 0.5s ease' : 'none'
                    }}
                >
                    ➡️
                </div>
            </div>

            {isHovered && (
                <div className="absolute inset-0 pointer-events-none">
                    {[...Array(3)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-2 h-2 bg-yellow-400 rounded-full"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animation: 'sparkle 1s ease-out infinite'
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

/* ---------------------------
       ✨ Lessons List
--------------------------- */
const LessonsList = ({ lessons, onLessonClick }) => {
    const ITEMS_PER_PAGE = 4;
    const [page, setPage] = useState(0);
    const nextSoundObject = useRef(new Audio(nextSound))

    const totalPages = Math.ceil(lessons.length / ITEMS_PER_PAGE);
    const currentLessons = lessons.slice(
        page * ITEMS_PER_PAGE,
        page * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );

    return (
        <div className="max-w-6xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {currentLessons.map((lesson, index) => (
                    <LessonCard
                        key={lesson.file}
                        lesson={lesson}
                        index={page * ITEMS_PER_PAGE + index}
                        onClick={() => onLessonClick(lesson.file)}
                    />
                ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center items-center gap-4 mt-8">
                <button
                    disabled={page === 0}
                    onClick={() => {
                        nextSoundObject.current.currentTime = 0;
                        nextSoundObject.current.play()
                        setPage(page - 1)
                    }}
                    className={`px-6 py-3 rounded-full font-bold text-lg shadow-lg 
            ${page === 0 ? "bg-gray-300 text-gray-700" : "bg-white hover:bg-gray-200"}`}
                >
                    السابق
                </button>

                <span className="text-white text-2xl font-bold">
                    {totalPages} / {page + 1}
                </span>

                <button
                    disabled={page === totalPages - 1}
                    onClick={() => {
                        nextSoundObject.current.currentTime = 0;
                        nextSoundObject.current.play()
                        setPage(page + 1)
                    }
                    }
                    className={`px-6 py-3 rounded-full font-bold text-lg shadow-lg 
            ${page === totalPages - 1 ? "bg-gray-300 text-gray-700" : "bg-white hover:bg-gray-200"}`}
                >
                    التالي
                </button>
            </div>
        </div>
    );
};

/* ---------------------------
        ✨ Main Page
--------------------------- */
const CategoryPage = () => {

    const [stars, setStars] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false); // New state for modal
    const { id: selectedCategory } = useParams();
    const lessons = categories[selectedCategory] || [];
    const icon = categoryIcons[selectedCategory] || "📚";
    const colorGradient = categoryColors[selectedCategory] || "from-blue-400 to-purple-400";
    const navigate = useNavigate();
    const backSoundObject = useRef(new Audio(backSound))

    useEffect(() => {
        const newStars = [];
        for (let i = 0; i < 30; i++) {
            newStars.push({
                id: i,
                size: Math.random() * 3 + 2,
                left: Math.random() * 100,
                top: Math.random() * 100,
                delay: Math.random() * 3
            });
        }
        setStars(newStars);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleLessonClick = (fileId) => {
        navigate(`/exercise/${selectedCategory}/${fileId}`);
    };

    const handleBack = () => {
        backSoundObject.current.currentTime = 0;
        backSoundObject.current.play();
        navigate('/');
    };

    // Handler to open the modal
    const handleShare = () => {
        setIsModalOpen(true);
    };

    return (
        <div>
            {/* The Share Modal */}
            <ShareModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                shareData={{ id: selectedCategory, title: selectedCategory }}
            />

            <div
                className={`min-h-screen py-8 relative overflow-hidden bg-gradient-to-br ${colorGradient} mb-6`}
                style={{ direction: 'rtl' }}
            >
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;700;900&display=swap');

                    body { font-family: 'Tajawal', sans-serif; }
                    @keyframes bounceIn { 0% { opacity: 0; transform: scale(0.3) translateY(-100px); } 
                      50% { transform: scale(1.05) translateY(0); } 70% { transform: scale(0.9); } 
                      100% { opacity: 1; transform: scale(1); } }
                    @keyframes slideIn { from { opacity: 0; transform: translateX(50px); } 
                      to { opacity: 1; transform: translateX(0); } }
                    @keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-15px); } }
                    @keyframes wiggle { 0%, 100% { transform: rotate(-5deg); } 50% { transform: rotate(5deg); } }
                    @keyframes bounce { 0%, 100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-20px) scale(1.2); } }
                    @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                    @keyframes moveRight { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(10px); } }
                    @keyframes sparkle { 0% { opacity: 0; transform: scale(0); } 50% { opacity: 1; } 
                      100% { opacity: 0; transform: scale(1.5); } }
                    @keyframes rainbow { 0% { filter: hue-rotate(0deg); } 
                      100% { filter: hue-rotate(360deg); } }
                    @keyframes twinkle { 0%, 100% { opacity: 0.3; transform: scale(1); } 
                      50% { opacity: 1; transform: scale(1.5); } }
                    @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }

                    .star { animation: twinkle 3s infinite; }
                `}</style>

                {/* النجوم */}
                <div className="fixed top-0 left-0 w-full h-full pointer-events-none">
                    {stars.map(star => (
                        <div
                            key={star.id}
                            className="star absolute bg-white rounded-full"
                            style={{
                                width: `${star.size}px`,
                                height: `${star.size}px`,
                                left: `${star.left}%`,
                                top: `${star.top}%`,
                                animationDelay: `${star.delay}s`
                            }}
                        />
                    ))}
                </div>

                <div className="relative z-10">
                    <CategoryHeader
                        categoryName={selectedCategory}
                        icon={icon}
                        onBack={handleBack}
                        onShare={handleShare} // Pass the handler to the header button
                    />

                    {lessons.length > 0 ? (
                        <LessonsList
                            lessons={lessons}
                            onLessonClick={handleLessonClick}
                        />
                    ) : (
                        <div className="text-center text-white text-3xl font-bold mt-12">
                            لا توجد دروس متاحة حالياً 📝
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CategoryPage;